import React, { useState } from "react";
import { Box, TextField, Button, Typography, CircularProgress } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const LoginPage = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "", api: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ email: "", password: "", api: "" });

    if (!email || !password) {
      setErrors((prev) => ({
        ...prev,
        email: !email ? "Email is required" : "",
        password: !password ? "Password is required" : "",
      }));
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${apiUrl}/login`, { email, password });

      localStorage.setItem("authToken", response.data.token);
      setIsAuthenticated(true); // Update state immediately
      setLoading(false);

      navigate("/dashboard"); // Redirect after successful login
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        setErrors((prev) => ({ ...prev, api: error.response.data.message || "Login failed" }));
      } else {
        setErrors((prev) => ({ ...prev, api: "An unexpected error occurred" }));
      }
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ bgcolor: "#f7f7f7", p: 3 }}
    >
      <Typography variant="h4" gutterBottom>Login</Typography>
      
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          variant="outlined"
          margin="normal"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={Boolean(errors.password)}
          helperText={errors.password}
        />
        
        {errors.api && (
          <Typography color="error" variant="body2" gutterBottom>
            {errors.api}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
        </Button>
      </form>
    </Box>
  );
};

export default LoginPage;
